import { ACDSessionManager } from '@nice-devone/core-sdk';
import { logger } from '../../../utils/logger';
import { getExtendedClient } from '../client-helpers';

/**
 * End agent session using ACDSessionManager
 */
export async function endAgentSession(): Promise<void> {
  logger.debug('[CXone SDK] Ending agent session...');

  try {
    const acdSession = ACDSessionManager.instance;
    const client = getExtendedClient();

    const response = await acdSession.endSession({
      forceLogoff: false,
      endContacts: true,
      ignorePersonalQueue: false,
    });

    if (response && 'errorCode' in response) {
      logger.warn('[CXone SDK] Session end warning:', response);
    }

    await client.clearCache();

    logger.debug('[CXone SDK] Agent session ended');
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    const errorStr = JSON.stringify(error);

    if (errorMessage.includes('InvalidAgentSession') || errorStr.includes('InvalidAgentSession')) {
      logger.debug('[CXone SDK] Session already ended or invalid, proceeding with cleanup');
      try {
        const client = getExtendedClient();
        await client.clearCache();
      } catch (cacheError) {
        logger.warn('[CXone SDK] Failed to clear cache:', cacheError);
      }
      return;
    }

    logger.error('[CXone SDK] Failed to end agent session:', error);
    throw error;
  }
}
